import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Deliverables } from '../components/Deliverables';
import { Audience } from '../components/Audience';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function SalesPage() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    window.fbq('init', '3073526226178659');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream-50 font-sans text-charcoal-900 selection:bg-teal-200 selection:text-teal-900" data-id="element-204">
      <main data-id="element-205">
        <Hero data-id="element-206" />
        <Problem data-id="element-207" />
        <Solution data-id="element-208" />
        <Deliverables data-id="element-209" />
        <Audience data-id="element-210" />
        <Pricing data-id="element-211" />
      </main>

      <Footer data-id="element-212" />
    </div>;
}